import React from "react";
import { getContentWithFallback } from "./contentHelpers";

/**
 * Higher Order Component that handles content fallback logic
 * @param {React.Component} WrappedComponent - The component to wrap
 * @param {Object} defaultContent - The default content to use for fallback
 * @returns {React.Component} - A new component with content fallback handling
 */
const withContentFallback = (WrappedComponent, defaultContent) => {
  return function WithContentFallback(props) {
    const { content, ...otherProps } = props;

    // Process content with fallback to defaults
    const processedContent = getContentWithFallback(content, defaultContent);

    // Pass the processed content to the wrapped component
    return <WrappedComponent content={processedContent} {...otherProps} />;
  };
};

export default withContentFallback;
